
const HtmlHead = ({ title = '', description = '', children = null }) => {
  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {children && children}
    </>
  );
};
export default HtmlHead;
